// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-133f689e] .el-range-editor.is-active:hover {\n  border-color: #409eff !important;\n}\n.demo-table-expand label[data-v-133f689e] {\n  width: 90px;\n}\n.el-icon-arrow-down[data-v-133f689e] {\n  font-size: 12px;\n}\n.icon-arrow-down[data-v-133f689e]  .el-dropdown-menu__item {\n  font-size: 12px;\n}\n.consistency-evidence[data-v-133f689e] {\n  white-space: pre-line;\n  line-height: 1.6;\n}\n[data-v-133f689e] .el-col-12 {\n  width: 100% !important;\n}", ""]);
// Exports
module.exports = exports;
